export function cretaeMessageContent(textHe, textAr, textEn, link) {

    return JSON.parse(`{
    "he": "{ \\"text\\": \\"${textHe}\\", \\"link\\": \\"${link}\\" }",
    "ar": "{ \\"text\\": \\"${textAr}\\", \\"link\\": \\"${link}\\" }",
    "en": "{ \\"text\\": \\"${textEn}\\", \\"link\\": \\"${link}\\" }"
    }`);

}